import { StyleSheet } from 'react-native';
import { WARMUP_COLORS, WARMUP_HUB } from '../../../src/quiz/constants/warmup.constants';

export const gameCardStyles = StyleSheet.create({
  cardWrap: {
    width: '48%',
  },
  // Image-banner card: artwork on top, centered text below (design grid card).
  // Fixed height so every card is identical regardless of how many lines its subtitle/meta take.
  card: {
    width: '100%',
    height: 252,
    backgroundColor: WARMUP_HUB.cardArtBg,
    borderRadius: 18,
    borderWidth: 1.5,
    overflow: 'hidden',
    shadowOpacity: 0.35,
    shadowRadius: 16,
    shadowOffset: { width: 0, height: 4 },
    elevation: 6,
  },

  imageArea: {
    position: 'relative',
    width: '100%',
    height: 138,
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  imagePlaceholder: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },

  soonBadge: {
    position: 'absolute',
    top: 9,
    right: 9,
    backgroundColor: 'rgba(15,10,24,0.85)',
    borderWidth: 1,
    borderColor: WARMUP_COLORS.border,
    borderRadius: 9999,
    paddingVertical: 3,
    paddingHorizontal: 9,
  },
  soonBadgeText: {
    fontSize: 10,
    fontWeight: '800',
    color: WARMUP_COLORS.textDim,
    letterSpacing: 0.6,
  },
  doneOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.55)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  donePill: {
    backgroundColor: WARMUP_COLORS.green,
    borderRadius: 9999,
    paddingVertical: 4,
    paddingHorizontal: 12,
  },
  donePillText: {
    fontSize: 11,
    fontWeight: '800',
    color: WARMUP_COLORS.textOnBright,
    letterSpacing: 0.6,
  },

  textArea: {
    flex: 1,
    paddingTop: 11,
    paddingBottom: 13,
    paddingHorizontal: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 15,
    lineHeight: 20,
    fontWeight: '800',
    color: WARMUP_COLORS.text,
    letterSpacing: -0.2,
    textTransform: 'uppercase',
    textAlign: 'center',
    paddingTop: 1,
  },
  subtitle: {
    fontSize: 12,
    lineHeight: 16,
    color: WARMUP_COLORS.textDim,
    marginTop: 4,
    fontWeight: '500',
    textAlign: 'center',
  },
  subtitleDone: {
    color: WARMUP_COLORS.green,
    fontWeight: '700',
  },

  meta: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    marginTop: 9,
  },
  metaItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  metaDivider: {
    width: 1,
    height: 14,
    backgroundColor: 'rgba(255,255,255,0.15)',
  },
  fire: {
    fontSize: 14,
    lineHeight: 15,
  },
  metaStreak: {
    fontSize: 14,
    fontWeight: '800',
    color: WARMUP_COLORS.text,
    fontVariant: ['tabular-nums'],
  },
  metaReward: {
    fontSize: 14,
    fontWeight: '800',
    color: WARMUP_COLORS.amber,
    fontVariant: ['tabular-nums'],
  },
  metaDone: {
    fontSize: 12,
    fontWeight: '700',
    color: WARMUP_COLORS.textDim,
  },

  pressed: { opacity: 0.85 },
  // Coming-soon (not-yet-live) games: dimmed so they read as unavailable. The SOON badge is
  // high-contrast and stays legible at this opacity.
  cardSoon: { opacity: 0.5 },
});
